import React from 'react';
import { Row, Col, Card } from 'antd';
import IssueEndorsementTable from './IssueEndorsementTable';
import IssueEndorsementFilter from './IssueEndorsementFilter';
import IssueEndorsementTotal from './IssueEndorsementTotal';

export default function IssueEndorsementReport() {
    
    return (
        <Card>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <IssueEndorsementFilter />
                    <IssueEndorsementTotal />
                    <IssueEndorsementTable />
                </Col>
            </Row>
        </Card>
    )
}